module.exports = "/../../dist/frontend/images/familiale.webp?f26ebbe92de62702f737268dd364a52a";